import userStatus from "../../utils/userStatus"
import Button from "../UI/Button"
import Input from "../../components/UI/Input";
import {
  EditOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from '@ant-design/icons';
import { IAccountsTableActionsProps } from "./types"
import { useNavigate } from 'react-router-dom'
import Modal from "antd/lib/modal/Modal";
import { useEffect, useState } from "react";
import { changeUserStatusById, createOrUpdateUser, getAffiliationOptions, getUserById } from "../../services/users";
import { Col, Row } from "antd";
import { InputMode } from "../../enums/inputTypeEnum"
import { notificationError } from "../../services/notification";

const AccountsTableButtons = (props: IAccountsTableActionsProps) => {
  const history = useNavigate()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isModalVisiblePassword, setIsModalVisiblePassword] = useState(false)
  const [form, setForm] = useState<any>({
    status: userStatus.active,
    encryptedPassword: '',
    passwordConfirm: ''
  })
  const [showPassword, setShowPassword] = useState(false)

  const verifyPassword = () => {
    if (!form.encryptedPassword || !form.passwordConfirm) return false
    if (form.encryptedPassword && form.encryptedPassword.length < 6) return false
    if (form.encryptedPassword.length > 128) return false
    return true
  }
  
  const changeUserStatus = async () => {
    let id = props.user.id
    let res: any = await getUserById({ id })
    if (props.user.status === userStatus.inactive) {
      if (!form.encryptedPassword && !id) return notificationError('Please insert a password')
      if ((form.encryptedPassword.length < 6 && !id) || (id && form.encryptedPassword && form.encryptedPassword.length < 6)) return notificationError('Password is too short (minimum is 6 characters)')
      if (form.encryptedPassword.length > 128) return notificationError('Password is too long (max is 128 characters)')
      if (form.passwordConfirm !== form.encryptedPassword) return notificationError('Please confirm your password')
      let payload = {
        ...res,
        encryptedPassword: form.encryptedPassword,
        status: props.user.status === userStatus.active ? userStatus.inactive : userStatus.active
      }
      let response = false
      response = await createOrUpdateUser({ id, ...payload })
      if (!response) {
        return notificationError("Error updating and activating user account.")
      }
    } else {
      const params = {
        id: props.user.id,
        status: props.user.status === userStatus.active ? userStatus.inactive : userStatus.active
      }
      await changeUserStatusById(params)
    }
    props.onChangeStatus()
    setIsModalVisible(false)
    setIsModalVisiblePassword(false)
  }

  return (
    <div className="accounts-table-actions">
      <Modal
        title={`The user ${props.user.name} will be ${props.user.status === userStatus.active ? 'deactivated' : 'activated'}, continue?`}
        open={isModalVisible}
        onOk={changeUserStatus}
        onCancel={() => setIsModalVisible(false)}
      />
      <Modal
        title={`The user ${props.user.name} will be ${props.user.status === userStatus.active ? 'deactivated' : 'activated'}, continue?`}
        open={isModalVisiblePassword}
        onOk={changeUserStatus}
        onCancel={() => setIsModalVisiblePassword(false)}
        okButtonProps={{ disabled: !verifyPassword() }}
        cancelButtonProps={{ disabled: false }}
      >
        <Row autoFocus={true}>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setForm({...form, 'encryptedPassword' : e.target.value})}
            value={form.encryptedPassword}
            label='Password*'
            placeholder='Password'
            inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
            innerProps={{ id: 'activate-account-password' }}
          />
        </Row>
        <Row align="middle">
          <Col>
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, 'passwordConfirm': e.target.value })}
              value={form.passwordConfirm}
              label='Password Confirmation*'
              placeholder='Password Confirmation'
              inputMode={showPassword ? InputMode.TEXT : InputMode.PASSWORD}
              innerProps={{ id: 'activate-account-password-confirm' }}
            />
          </Col>
          <Col>
            <Button style={{ width: 30, display: 'block' }} onClick={() => setShowPassword((prevState) => !prevState)}>
              {!showPassword &&
                <EyeInvisibleOutlined />
              }
              {showPassword &&
                <EyeTwoTone />
              }
            </Button>
          </Col>
        </Row>
      </Modal>
      <Button
        disabled={props.disabled || props.user.canEdit === 'No'}
        onClick={() => {props.user.status === userStatus.active ? setIsModalVisible(true) : setIsModalVisiblePassword(true)}}
        style={{backgroundColor: props.user.status === userStatus.active ? '#bd4247' : '#669533', minWidth: '100px'}}
        type='primary'
      >
        <p id={'change-status-' + props.index}>{props.user.status === userStatus.active ? 'Deactivate' : 'Activate'}</p>
      </Button>
      <Button 
        disabled={props.disabled || props.user.canEdit === 'No'}
        onClick={() => history(`../users/new/${props.user.id}`)}
        type='primary'
        style={{backgroundColor: '#2fa4e7'}}
      >
        <EditOutlined id={'edit-page-' + props.index} style={{ fontSize: '16px', color: '#FFF' }} />
      </Button>
    </div>
  )
}

export default AccountsTableButtons